import { IAssessmentMessage } from "./interfaces/assessment-message";

export class AssessmentMessage implements IAssessmentMessage {

  constructor(optionValueId: number) {
    this.index = 1;
    this.isDeleted = false;
    this.optionValueId = optionValueId;
  }

  assessmentMessageId: number;
  title: string;
  description: string;
  linkToImage: string;
  showAllContentOnSameLine: boolean;
  isHyperlink: boolean;
  optionValueId: number;
  index: number;
  isDeleted: boolean;

  isValid(): boolean { throw new Error("Not implemented"); }

  prepare(): void { throw new Error("Not implemented"); }
}
